const topics = [
  { label: '流浪地球3', hot: '🔥 98.6万讨论', color: 'bg-accent-100 text-accent-700 border-accent-300' },
  { label: '暑期档推荐', hot: '🔥 87.3万讨论', color: 'bg-primary-100 text-primary-700 border-primary-300' },
  { label: '封神第二部', hot: '🔥 76.2万讨论', color: 'bg-secondary-100 text-secondary-700 border-secondary-300' },
  { label: '大奉打更人', hot: '🔥 65.8万讨论', color: 'bg-accent-100 text-accent-700 border-accent-300' },
  { label: '庆余年3', hot: '🔥 59.4万讨论', color: 'bg-primary-100 text-primary-700 border-primary-300' },
  { label: '奥本海默', hot: '🔥 52.1万讨论', color: 'bg-secondary-100 text-secondary-700 border-secondary-300' },
  { label: 'AI科幻电影', hot: '🔥 48.7万讨论', color: 'bg-primary-100 text-primary-700 border-primary-300' },
  { label: '国产动漫崛起', hot: '🔥 43.5万讨论', color: 'bg-accent-100 text-accent-700 border-accent-300' },
  { label: '经典港片回顾', hot: '🔥 38.9万讨论', color: 'bg-secondary-100 text-secondary-700 border-secondary-300' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-3">
            话题热度
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
            热门话题
          </h2>
          <p className="text-sm text-foreground-500 mt-3 max-w-lg mx-auto">
            看看大家都在讨论什么，跟上影迷圈的最新热点
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {topics.map((topic) => (
            <a
              key={topic.label}
              href="#cards"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className={`group flex items-center gap-3 px-5 py-3 rounded-xl border cursor-pointer transition-all duration-200 hover:shadow-sm ${topic.color}`}
            >
              <span className="text-sm font-semibold whitespace-nowrap">{topic.label}</span>
              <span className="text-xs opacity-70 whitespace-nowrap">{topic.hot}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}